import Loadable from 'react-loadable';

import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () =>
    import('./Promo50' /* webpackChunkName: "PromotionLandingPage" */),
  loading: LoadingIndicator,
});
